package com.nonopn.skywatcher.common.app.pages.map.view.map

import androidx.compose.foundation.background
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.pages.map.model.weather.ActivityAge
import com.nonopn.skywatcher.design.local.LocalFontSizes
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.TextNormal

@Composable
fun LightningActivityLegend(
    modifier: Modifier
) {
    MapOverlayCard(modifier) {
        Row(
            modifier = Modifier.padding(8.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            TextNormal(
                text = "0min",
                fontSize = LocalFontSizes.current.map.activityLightning
            )

            MapOverlayCard(Modifier.weight(1.0f)) {
                Box(
                    modifier = Modifier.fillMaxSize()
                        .background(Brush.horizontalGradient(colors = ActivityAge.entries.map { it.color }))
                )
            }

            TextNormal(
                text = "+20min",
                fontSize = LocalFontSizes.current.map.activityLightning
            )
        }
    }
}

@Composable
@HotPreview(widthDp = 600, heightDp = 400, darkMode = true)
@HotPreview(widthDp = 600, heightDp = 400, darkMode = false)
private fun Preview() {
    HotPreviewApp(
        Modifier.fillMaxSize().padding(10.dp),
        isDarkTheme = isSystemInDarkTheme()
    ) {
        LightningActivityLegend(
            Modifier.fillMaxSize()
        )
    }
}